export const checkPermission = (rule, role) => {

    if (rule.constructor === RegExp) {
        return rule.test(role);
    }

    return rule === role;
};

export const checkPermissions = (rules, role) => {

    // If no rules are added, assume allowed
    if (!role) return false;


    if (!rules || !rules.length) {
        return true;
    }


    return rules.map(rule => checkPermission(rule, role)).includes(true);

};


export const scopeValidator = (userRole, requiredRole) => {

    if (userRole === 'admin') {
        return true;
    }

    if (!userRole || !requiredRole) {
        return false;
    }

    if (typeof requiredRole === 'string'){
        return userRole === requiredRole;
    }

    return requiredRole.some(role => role === userRole);
};

export const filterArrayByRole = (array, role) => array.filter(obj => {

    if (!obj.rules) {
        return true;
    }

    return checkPermissions(obj.rules, role);
});
